<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        setTimeout(async function(){
            let respManufacturers = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {type:"TRUCK_TRAILER"}, `${Endpoints.parts.manufacturer.listByType}`)).data;
            if (respManufacturers.status==200){
                payload.manufacturers = respManufacturers.results;
            }
        }, 100);
        
    },
    methods:{
        selectItem: function(item){
            let copy = JSON.parse(JSON.stringify(item));
            
            if(copy.actualKM){
                copy.actualKM = Number(copy.actualKM)
            }
 
            if(copy.manufacturer && copy.manufacturer._id){
                copy.manufacturer = copy.manufacturer._id;
            }

            if(copy.truckDriver && copy.truckDriver._id){
                copy.truckDriver = copy.truckDriver._id;
            }
            
            copy.oldDocumentPhotoURL = copy.documentPhotoURL;
            this.$emit('load-item', copy);
        },
        filter: function(){
                let payload = this;
                payload.items = [];
                setTimeout(async function(){
                    let truck = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload),  payload.filters, `${Endpoints.trucks.listByType}`));
                    console.log(truck.data.results);
                    if (truck.status==200){
                        payload.items = truck.data.results;
                    }
                }, 100);
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase
    }
}
</script>
